// extracted by mini-css-extract-plugin
export var disabled = "_s4-0";